var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 56,
    viewBox: "0 0 62 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.7509 22.1103L59.9548 42.5537H2.23758L0.441406 22.1103L10.6593 15.5732H51.5331L61.7509 22.1103Z",
    fill: "#FEB920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7505 22.1103L59.9543 42.5537H31.0957V15.5732H51.5326L61.7505 22.1103Z",
    fill: "#FC9B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6602 2.49902H51.534V43.6829H10.6602V2.49902Z",
    fill: "#E6F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0957 2.49902H51.5326V43.6829H31.0957V2.49902Z",
    fill: "#BBE4F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.957 8.73486H31.0946V11.9524H17.957V8.73486Z",
    fill: "#393E9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.957 16.5791H44.2315V19.7967H17.957V16.5791Z",
    fill: "#393E9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.957 24.4238H44.2315V27.6414H17.957V24.4238Z",
    fill: "#393E9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0957 16.5791H44.2329V19.7967H31.0957V16.5791Z",
    fill: "#340D66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0957 24.4238H44.2329V27.6414H31.0957V24.4238Z",
    fill: "#340D66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7509 22.1104V53.4892L31.0962 50.9388L0.441406 53.4892V22.1104L24.9652 37.8003H37.2271L61.7509 22.1104Z",
    fill: "#FFCF67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7505 22.1104V53.4892L31.0957 50.9388V37.8003H37.2267L61.7505 22.1104Z",
    fill: "#FEB920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7509 53.4891H0.441406L31.0962 33.8779L61.7509 53.4891Z",
    fill: "#FEB920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7505 53.4891H31.0957V33.8779L61.7505 53.4891Z",
    fill: "#FC9B28"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.3095,
    height: 54.9133,
    fill: "white",
    transform: "translate(0.441406 0.537598)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.a32aecdaccd4982698255791379f0eb1.svg";
export { ForwardRef as ReactComponent };